import Guard from 'arg-guard'

import Store from '../store'
import { MUTATIONS } from '../store/mutations'

import EditablePropertyDataItem from '../models/editable-property-data-item'
import Segment from '../models/segment'

/*
 * Functions that deal with managing editable stores.
 */
const PropertyManagerEdits = {

    /**
     * Clears the edits in state.
     */
    clear() {
        Store.commit(MUTATIONS.MYHOME.clearEdits)
    },

    /**
     * Initialises the edit state for a segment.
     *
     * @param {Segment} segments The segments to initialise with.
     */
    initialise(segment) {
        Guard.throwIf(segment, 'segment')

        if (!(segment instanceof Segment))
            throw new TypeError('The segment parameter must be of type Segment.')

        Store.commit(MUTATIONS.MYHOME.initialiseEdits, segment)
    },

    /**
     * Updates the data for the provided editable.
     *
     * @param {EditablePropertyDataItem} editData The editable object.
     */
    update(editData) {
        Guard.throwIf(editData, 'editData')
        if (!(editData instanceof EditablePropertyDataItem))
            throw new TypeError('The editData parameter must be of type EditablePropertyDataItem.')

        Store.commit(MUTATIONS.MYHOME.updateEdit, {
            dottedString: editData.dottedString,
            newValue: editData.editedValue,
            payload: editData.payload,
        })
    },
}

export default PropertyManagerEdits
